import { Button } from '@material-ui/core';
import { useEffect } from 'react';
import en from '../../../../lang/en-us';
import SuccessScreen from './../SuccessScreen';
const { dashboard } = en;

export default function LockUnlockFoliosSuccess(props: any) {
    const { reqId, operation } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/portal/nct');
            return;
        }
    }, []);

    const operationText = operation === 'L' ? 'Lock' : 'Unlock';

    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={`${operationText} Folios - Success`}
                backLink="nct"
                info1={`${operationText} Folios Request`}
                infospan1="Request ID"
                info2="Your request has been submitted successfully"
                infospan2={`${reqId}`}
                info3="You can track the status of your request"
                list={[]}
                handleClick={() => props.history.push('/portal/track')}
                backNavigation={() => props.history.push('/portal/nct/lock-unlock-folios')}
            />
        </div>
    );
}
